import { Divider, FormControl, IconButton, InputLabel, MenuItem, Select, Typography, useMediaQuery } from "@mui/material";
import { ArrowCircleRight as ArrowCircleRightIcon, BackupTable as BackupTableIcon, Palette as PaletteIcon, BorderHorizontal as BorderHorizontalIcon, FontDownload as FontDownloadIcon, SmartButton as SmartButtonIcon, ViewCarousel as ViewCarouselIcon, MenuBook as MenuBookIcon, KeyboardBackspace as KeyboardBackspaceIcon } from "@mui/icons-material"
import { useTranslation } from "react-i18next";

export default function DesignMenuOptions({ instance, styleOption, handleChangeStyleOption, returnBack }) {
  const { t } = useTranslation()
  const mdMQ = useMediaQuery(theme => theme.breakpoints.up('md'));

  return (<>
    <Typography variant="h6" style={{ display: "flex", alignItems: "center" }}>
      <IconButton onClick={returnBack} style={{ marginRight: 4 }}> <KeyboardBackspaceIcon /> </IconButton>
      <MenuBookIcon color="primary" style={{ marginRight: 4 }}/> {instance.name}
    </Typography>
    <Divider sx={{ marginTop: 1, marginBottom: 3 }} />
    <div style={{ display: "grid", gridTemplateColumns: mdMQ ? "1fr 1fr" : "1fr", gap: 8, position: "sticky", top: mdMQ ? 64 : 55, backgroundColor: "#ffffff", zIndex: 2, padding: 4 }}>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <Typography variant="h6">{t('designmenu_menu_design_text')}</Typography> &nbsp;&nbsp; <ArrowCircleRightIcon />
      </div>
      <FormControl>
        <InputLabel id="demo-simple-select-label">{t('designmenu_select_options_placeholder')}</InputLabel>
        <Select
          size="small"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={styleOption}
          label="Selección de opciones"
          onChange={handleChangeStyleOption}
        >
          <MenuItem value={0}>{t('designmenu_select_option_options')}</MenuItem>
          <MenuItem value={6}><BackupTableIcon /> &nbsp; {t('designmenu_select_option_layout')}</MenuItem>
          <MenuItem value={1}><PaletteIcon /> &nbsp; {t('designmenu_select_option_general_features')}</MenuItem>
          <MenuItem value={2}><SmartButtonIcon /> &nbsp; {t('designmenu_select_option_header')}</MenuItem>
          <MenuItem value={3}><ViewCarouselIcon /> &nbsp; {t('designmenu_select_option_navigation_menu')}</MenuItem>
          <MenuItem value={4}><BorderHorizontalIcon /> &nbsp; {t('designmenu_select_option_separators')}</MenuItem>
          <MenuItem value={5}><FontDownloadIcon /> &nbsp; {t('designmenu_select_option_typography')}</MenuItem>
        </Select>
      </FormControl>
    </div>
    <Divider sx={{ marginTop: 3, marginBottom: 3 }} />
  </>)
}